
if (window.location.pathname.startsWith("/search")) {
    const params = new URLSearchParams(window.location.search);
    const searchQuery = params.get("q")?.toLowerCase();

    const redirectRules = [

        {
            terms: ["lbrqr10fh", "lbrqr13fh", "vulcan adjustable handle", "vulcan adjustable handle binders", "folding handle", "folding handle binders", "adjustable handle binders", "adjustable binders", "quick binders"],
            redirectTo: "https://www.truckntow.com/collections/search-folding-handle-load-binders-for-securing-cargo"
        },
        {
            terms: ["lighting"],
            redirectTo: "https://www.truckntow.com/collections/search-wireless-led-towing-and-trailer-light-kits"
        },
        {
            terms: ["ah22eewp-4p", "ah22eewp", "ah22eewp-ps-4p", "ah22eewp-ss-4pdog bone strap", "dog bone straps", "eye to eye axle strap"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps"
        },
        {
            terms: ["whelen", "whelan"],
            redirectTo: "https://www.truckntow.com/collections/search-amber-led-beacons-and-warning-lights-for-vehicles"
        },
        {
            terms: ["grade 100 binder chain"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-1"
        },
        {
            terms: ["rs208st10-2p"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-2"
        },
        {
            terms: ["foxfire", "fox fire", "foxfires", "fox fires"],
            redirectTo: "https://www.truckntow.com/collections/search-amber-led-beacons-and-warning-lights-for-vehicles-1"
        },
        {
            terms: ["jumper", "jumpers"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection"
        },
        {
            terms: ["clearance etrack", "clearance e-track", "clearanceetrack", "clearancee-track", "clearance e track"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-1"
        },
        {
            terms: ["boat", "boats", "boating", "boat stuff", "boat equipment", "boating stuff", "boating equipment", "boat lock", "boat locks"],
            redirectTo: "https://www.truckntow.com/collections/search-wireless-led-towing-and-trailer-light-kits-1"
        },
        {
            terms: ["nsee2-94-10"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-2"
        },
        {
            terms: ["wide load", "wideload", "widelode", "wydeload", "wydelode", "wide lode", "wyde lode", "wyde load"],
            redirectTo: "https://www.truckntow.com/collections/search-amber-led-beacons-and-warning-lights-for-vehicles-2"
        },
        {
            terms: ["btk"],
            redirectTo: "https://www.truckntow.com/collections/search-folding-handle-load-binders-for-securing-cargo-1"
        },
        {
            terms: ["led flashers.ledflashers", "ledflasher", "led flasher"],
            redirectTo: "https://www.truckntow.com/collections/search-amber-led-beacons-and-warning-lights-for-vehicles-3"
        },
        {
            terms: ["atk2", "atk"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-3"
        },
        {
            terms: ["rs227c12"],
            redirectTo: "https://www.truckntow.com/collections/search-high-strength-ratchet-straps-for-vehicle-securement"
        },
        {
            terms: ["rs227f12"],
            redirectTo: "https://www.truckntow.com/collections/search-high-strength-ratchet-straps-for-vehicle-securement-1"
        },
        {
            terms: ["wbs-36sph"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-3"
        },
        {
            terms: ["wbs-36sth"],
            redirectTo: "https://www.truckntow.com/collections/search-tie-down-straps-with-hooks-for-safe-cargo-control"
        },
        {
            terms: ["wbs-36sth1l", "wbs-36sthil"],
            redirectTo: "https://www.truckntow.com/collections/search-tie-down-straps-with-hooks-for-safe-cargo-control-1"
        },
        {
            terms: ["tz-48gtr"],
            redirectTo: "https://www.truckntow.com/collections/search-safety-chains-with-grab-hooks-for-secure-tie-downs"
        },
        {
            terms: ["atk224"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-4"
        },
        {
            terms: ["atk223"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-5"
        },
        {
            terms: ["th024", "tho24"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-4"
        },
        {
            terms: ["ltl749"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-5"
        },
        {
            terms: ["battery flasher", "batteryflasher", "batterie flasher", "batterieflasher", "batteriesflasher", "batteries flaster", "batterys flasher", "batterysflasher"],
            redirectTo: "https://www.truckntow.com/collections/search-amber-led-beacons-and-warning-lights-for-vehicles-4"
        },
        {
            terms: ["volcan clasic", "volcan clasi", "volcan clasis", "volcan classic"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-6"
        },
        {
            terms: ["ah5210dr", "ahs210dr", "ah52i0dr", "ah521odr"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-7"
        },
        {
            terms: ["ah2-thick", "ah2thick", "ah-thick", "ahthick"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-8"
        },
        {
            terms: ["ah2-flex", "ah2flex", "ahflex", "ah-flex"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-9"
        },
        {
            terms: ["ltl085"],
            redirectTo: "https://www.truckntow.com/collections/search-amber-led-beacons-and-warning-lights-for-vehicles-5"
        },
        {
            terms: ["drb13sp", "drb13sp-2p", "snddrb13sp-2p", "drb13sp-4p", "stake pocket", "stake pockets"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-6"
        },
        {
            terms: ["ws227f12-ps", "ws230f12-ps"],
            redirectTo: "https://www.truckntow.com/collections/search-tie-down-straps-with-hooks-for-safe-cargo-control-2"
        },
        {
            terms: ["ws427f20", "ws430f20c10"],
            redirectTo: "https://www.truckntow.com/collections/search-tie-down-straps-with-hooks-for-safe-cargo-control-3"
        },
        {
            terms: ["ws227c12", "ws230c12"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-winch-straps-and-accessories-for-trailers"
        },
        {
            terms: ["ws227w12", "ws230w12"],
            redirectTo: "https://www.truckntow.com/collections/search-tie-down-straps-with-hooks-for-safe-cargo-control-4"
        },
        {
            terms: ["ws227f12", "ws230f12"],
            redirectTo: "https://www.truckntow.com/collections/search-tie-down-straps-with-hooks-for-safe-cargo-control-5"
        },
        {
            terms: ["rs227c12-ps", "rs227c12-ps-2p", "rs230c12"],
            redirectTo: "https://www.truckntow.com/collections/search-high-strength-ratchet-straps-for-vehicle-securement-2"
        },
        {
            terms: ["rs227f12-ps", "rs227f12-ps-2p", "rs230f12-2p"],
            redirectTo: "https://www.truckntow.com/collections/search-high-strength-ratchet-straps-for-vehicle-securement-3"
        },
        {
            terms: ["lbl10"],
            redirectTo: "https://www.truckntow.com/collections/search-folding-handle-load-binders-for-securing-cargo-2"
        },
        {
            terms: ["lbr10-hd"],
            redirectTo: "https://www.truckntow.com/collections/search-folding-handle-load-binders-for-securing-cargo-3"
        },
        {
            terms: ["vets", "vets06", "vet06-hd", "vets06-5"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-7"
        },
        {
            terms: ["lser"],
            redirectTo: "https://www.truckntow.com/collections/search-high-strength-ratchet-straps-for-vehicle-securement-4"
        },
        {
            terms: ["assp", "a5sp", "a55p", "as5p"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-8"
        },
        {
            terms: ["lbe903", "lbe904"],
            redirectTo: "https://www.truckntow.com/collections/search-amber-led-beacons-and-warning-lights-for-vehicles-6"
        },
        {
            terms: ["height", "height stick", "height sticks"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-9"
        },
        {
            terms: ["th011-k4-s"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-10"
        },
        {
            terms: ["27foot10packs"],
            redirectTo: "https://www.truckntow.com/collections/search-high-strength-ratchet-straps-for-vehicle-securement-5"
        },
        {
            terms: ["cargo winches", "cargo winch's", "cargo winchs", "cargo whinches", "cargo whinch's", "cargo whinchs"],
            redirectTo: "https://www.truckntow.com/collections/search-high-strength-ratchet-straps-for-vehicle-securement-6"
        },
        {
            terms: ["recovery strap", "recovery straps"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-10"
        },
        {
            terms: ["off road rope", "recovery rope", "tow rope", "off road ropes", "recovery ropes", "tow ropes"],
            redirectTo: "https://www.truckntow.com/collections/search-towing-equipment-and-accessories-for-vehicle-recovery"
        },
        {
            terms: ["si028", "sio28", "s1028", "s1o28"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-11"
        },
        {
            terms: ["wire harness", "wiring harness"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-12"
        },
        {
            terms: ["frame hooks", "frame hook", "fram hook", "fram hooks"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-11"
        },
        {
            terms: ["mini bars", "mini light bars", "mini light bar", "mini bar", "small light bar", "small light bars"],
            redirectTo: "https://www.truckntow.com/collections/search-amber-led-beacons-and-warning-lights-for-vehicles-7"
        },
        {
            terms: ["vulcan light", "vulcan lights"],
            redirectTo: "https://www.truckntow.com/collections/search-wireless-led-towing-and-trailer-light-kits-2"
        },
        {
            terms: ["ft-72tj"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-12"
        },
        {
            terms: ["rb2"],
            redirectTo: "https://www.truckntow.com/collections/search-safety-chains-with-grab-hooks-for-secure-tie-downs-1"
        },
        {
            terms: ["vulcan straps", "vulcan strap"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-13"
        },
        {
            terms: ["liftcomp"],
            redirectTo: "https://www.truckntow.com/collections/search-safety-chains-with-grab-hooks-for-secure-tie-downs-2"
        },
        {
            terms: ["snap hook straps", "snap hook strap"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-14"
        },
        {
            terms: ["tk1-th050p"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-15"
        },
        {
            terms: ["premium car hauler straps"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-16"
        },
        {
            terms: ["tow light plug", "tow light plugs", "4 plug", "6 plug", "7 plug", "4 wire", "6 wire", "7 wire", "4 wire round", "7 wire blade", "4plug", "6plug", "7plug"],
            redirectTo: "https://www.truckntow.com/collections/search-towing-equipment-and-accessories-for-vehicle-recovery-1"
        },
        {
            terms: ["wheel cover", "wheel covers", "wheelcover", "wheelvocers", "steering wheel cover", "steering wheel covers"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-13"
        },
        {
            terms: ["vinyl tarps", "vinyl tarp"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-14"
        },
        {
            terms: ["th009", "th0o9", "thoo9", "tho09", "th009-k4", "th009-k4-ss", "th009-k4-hv", "th009-k4-ps"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-17"
        },
        {
            terms: ["ah5", "ah52", "ah521", "ah5210", "ah521o", "ah52io", "ah52i0", "ahs210", "ahs2io", "ahs2i0", "ahs21o"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-18"
        },
        {
            terms: ["ah3", "ah36", "ah36d", "ah36dr", "ah36dr-wp"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-19"
        },
        {
            terms: ["warn winch", "tow winch", "warn whinches", "tow whinches", "warn winch's", "tow winch's", "hydraulic winch", "hydraulic winches", "hydraulic winch's", "electric winch", "electric winches", "electric winch's"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-winch-straps-and-accessories-for-trailers-1"
        },
        {
            terms: ["whelen lights", "whelen light bar", "whelen light bars", "whelen light", "whelen lightbars", "whelen light bar"],
            redirectTo: "https://www.truckntow.com/collections/search-towing-equipment-and-accessories-for-vehicle-recovery-2"
        },
        {
            terms: ["latch", "latche", "latch's", "latches", "latch lock", "latch locks", "tool box latch", "tool box latches"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-15"
        },
        {
            terms: ["mesh oversize load sign", "mesh oversize load signs", "mesh banners", "banners"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-16"
        },
        {
            terms: ["hinged oversize load sign", "hinged oversize load signs", "hinged wide load sign", "hinged wide load signs", "hinged signs", "aluminum oversize load sign", "aluminum oversize load signs", "aluminum wide load sign", "aluminum wide load signs", "folding oversize load sign", "folding oversize load signs"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-17"
        },
        {
            terms: ["poly fender", "poly fenders", "fender mounting brackets", "fender mounting bracket"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-18"
        },
        {
            terms: ["cone holder", "cone holders"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-19"
        },
        {
            terms: ["road flares", "flares", "led flares", "flare holder", "flare stands"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-20"
        },
        {
            terms: ["mounting boxes", "light mounting boxes", "light box.light boxes"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-21"
        },
        {
            terms: ["light bracket", "light brackets", "beacon bracket", "mirror mount"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-22"
        },
        {
            terms: ["reflective tape", "reflective tape", "tape"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-23"
        },
        {
            terms: ["si050", "spring flag", "spring warning flag", "spring flags", "spring warning flags. si050-2p"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-24"
        },
        {
            terms: ["chrome simulators", "simulators", "dot wheel simulators", "wheel simulator", "wheel cover", "wheel covers", "simulator", "wheel sim", "wheel simulators", "chrome simulator"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-25"
        },
        {
            terms: ["jumper cable", "jumper cables", "booster cable", "booster cables"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-26"
        },
        {
            terms: ["tarp straps", "bungee strap", "bungee straps", "rubber straps", "rubber strap", "tarp strap", "rubber tarp straps", "rubber tarp strap", "bungee", "bungees", "bungie", "bungies"],
            redirectTo: "https://www.truckntow.com/collections/search-tie-down-straps-with-hooks-for-safe-cargo-control-6"
        },
        {
            terms: ["backup alarms", "backup alarm"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-27"
        },
        {
            terms: ["flags", "warning flags", "warning flag", "safety flags", "safety flags", "truck flags", "truck flag"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-28"
        },
        {
            terms: ["wire loop flag", "wire loop flags"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-29"
        },
        {
            terms: ["j hook", "j hooks"],
            redirectTo: "https://www.truckntow.com/collections/search-high-strength-ratchet-straps-for-vehicle-securement-7"
        },
        {
            terms: ["flashing lights"],
            redirectTo: "https://www.truckntow.com/collections/search-amber-led-beacons-and-warning-lights-for-vehicles-8"
        },
        {
            terms: ["king pin lock", "king pin locks"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-30"
        },
        {
            terms: ["classic atk"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-20"
        },
        {
            terms: ["first aid kit", "first aid kits", "first aid"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-31"
        },
        {
            terms: ["axle forks", "axle fork"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-32"
        },
        {
            terms: ["rope clip", "ubolt", "u bolt", "cable clamp", "wire rope clip"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-33"
        },
        {
            terms: ["th011-k4-ce-"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-21"
        },
        {
            terms: ["mechanical connecting links", "hammerlok connector", "hammerlok connectors", "hammerlock connector", "hammerlock connectors", "hammerlock", "hammerlok", "connecting link", "connecting links"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-34"
        },
        {
            terms: ["vulcan snatch block", "vulcan snatch blocks", "snatch block", "snatch blocks"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-35"
        },
        {
            terms: ["th011-k4", "th0i1-k4", "th0ii-k4", "th01i-k4", "th011k4", "th0i1k4", "th0iik4", "th01ik4", "tho11-k4", "thoi1-k4", "thoii-k4", "tho1i-k4", "tho11k4", "thoi1k4", "thoiik4", "tho1ik4"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-22"
        },
        {
            terms: ["tire thumper", "tire thumpers"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-36"
        },
        {
            terms: ["th001", "tho01", "thoo1", "th0o1", "th00i", "tho0i", "thooi", "th0oi"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-23"
        },
        {
            terms: ["th009-hv", "th0o9-hv", "th009hv", "th0o9hv", "tho09-hv", "thoo9-hv", "tho09hv", "thoo9hv"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-24"
        },
        {
            terms: ["bulk chain"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-37"
        },
        {
            terms: ["2 inch winch strap 4 packs"],
            redirectTo: "https://www.truckntow.com/collections/search-tie-down-straps-with-hooks-for-safe-cargo-control-7"
        },
        {
            terms: ["ratchet winch", "ratcheting winchs", "ratchet winchs", "ratchet winches", "strap winder", "winch bars", "winch ratchet", "ratcheting winch"],
            redirectTo: "https://www.truckntow.com/collections/search-high-strength-ratchet-straps-for-vehicle-securement-8"
        },
        {
            terms: ["shackle", "shackles", "schackels", "schackel", "heavy duty webbing shackels", "heavy duty webbing shackles"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-38"
        },
        {
            terms: ["grab hooks", "grab hook"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-39"
        },
        {
            terms: ["made in the usa", "made in the usa", "made in the usa products", "made in the usa products", "made in the usa product", "made in usa"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-25"
        },
        {
            terms: ["t hook", "t hooks", "t hook", "t hooks"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-40"
        },
        {
            terms: ["th050", "th05o", "tho50", "tho5o"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-26"
        },
        {
            terms: ["4\" winch strap kits"],
            redirectTo: "https://www.truckntow.com/collections/search-tie-down-straps-with-hooks-for-safe-cargo-control-8"
        },
        {
            terms: ["axle tie down kits", "axle tie down kit", "axle kit", "axle tie down system", "axle tie down systems", "axle strap kit", "axle strap kits"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-27"
        },
        {
            terms: ["8-point tie down kits", "8 point"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-28"
        },
        {
            terms: ["tie down by the frame", "by the frame tie down", "ft-", "frame hook tie down", "frame hook tie downs", "frame hook strap", "frame hook straps"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-29"
        },
        {
            terms: ["tie down over the tire", "sliding idler", "rolling idler", "3 cleat tie down", "3 cleat", "sliding idler tie down", "rolling idler tie down", "over the tire tie down", "th051", "th0s1", "th05i", "th0si", "tho51", "thos1", "tho5i", "thosi", "over the tire straps", "straps over the tire"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-30"
        },
        {
            terms: ["tie down around the tire", "around the tire tie down", "around the tire straps", "straps around the tire"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-31"
        },
        {
            terms: ["binder chain kit", "binder chain kits", "btk", "chain and binder kit", "chain and binder kits"],
            redirectTo: "https://www.truckntow.com/collections/search-folding-handle-load-binders-for-securing-cargo-4"
        },
        {
            terms: ["wide load kits", "wide load kit", "oversize load kits", "oversize load kit", "oversized load kits", "oversized load kit", "wlk"],
            redirectTo: "https://www.truckntow.com/collections/search-amber-led-beacons-and-warning-lights-for-vehicles-9"
        },
        {
            terms: ["t-ehp5", "tehp5", "t-ehps", "tehps", "horizontal e track", "horizontal etrack", "vertical e track", "vertical etrack", "horizontal e-track", "vertical e-track"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-41"
        },
        {
            terms: ["th047", "tho47"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-32"
        },
        {
            terms: ["th009-ps", "th0o9-p5", "th009ps", "th0o9p5", "tho09-ps", "thoo9-p5", "tho09ps", "thoo9p5"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-33"
        },
        {
            terms: ["th009-ss", "th0o9-ss", "th009-5s", "th0o9-s5", "th009ss", "th0o9ss", "th0095s", "th0o9s5", "tho09-ss", "thoo9-ss", "tho09-5s", "thoo9-s5", "tho09ss", "thoo9ss", "tho095s", "thoo9s5"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-34"
        },
        {
            terms: ["oval lights", "oval light"],
            redirectTo: "https://www.truckntow.com/collections/search-amber-led-beacons-and-warning-lights-for-vehicles-10"
        },
        {
            terms: ["th050-k4ss", "th0s0-k4ss", "th05o-k4ss", "th0so-k4ss", "th050k4ss", "th0s0k4ss", "th05ok4ss", "th0sok4ss", "tho50-k4ss", "thos0-k4ss", "tho5o-k4ss", "thoso-k4ss", "tho50k4ss", "thos0k4ss", "tho5ok4ss", "thosok4ss"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-35"
        },
        {
            terms: ["th050-k4ref", "th0s0-k4ref", "th05o-k4ref", "th0so-k4ref", "th050k4ref", "th0s0k4ref", "th05ok4ref", "th0sok4ref", "tho50-k4ref", "thos0-k4ref", "tho5o-k4ref", "thoso-k4ref", "tho50k4ref", "thos0k4ref", "tho5ok4ref", "thosok4ref", "th050-k4-hv"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-36"
        },
        {
            terms: ["ft-96rt"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-37"
        },
        {
            terms: ["shortend", "shortend ratchet buckle", "shortends", "short end", "short ends"],
            redirectTo: "https://www.truckntow.com/collections/search-high-strength-ratchet-straps-for-vehicle-securement-9"
        },
        {
            terms: ["ratchet buckle", "ratchet buckles", "rachet", "rachet buckle", "rachet buckles"],
            redirectTo: "https://www.truckntow.com/collections/search-safety-chains-with-grab-hooks-for-secure-tie-downs-3"
        },
        {
            terms: ["th008", "th0o8", "tho08", "thoo8"],
            redirectTo: "https://www.truckntow.com/collections/search-tie-down-straps-with-hooks-for-safe-cargo-control-9"
        },
        {
            terms: ["wheel lift straps", "wheel lift", "wheel lift harness", "wheel dolly straps", "dolly straps"],
            redirectTo: "https://www.truckntow.com/collections/search-tie-down-straps-with-hooks-for-safe-cargo-control-10"
        },
        {
            terms: ["th011", "th0i1", "th0ii", "th01i", "tho11", "thoi1", "thoii", "tho1i"],
            redirectTo: "https://www.truckntow.com/collections/search-heavy-duty-car-tie-down-straps-and-axle-straps-38"
        },
        {
            terms: ["tarp", "tarps", "tarp kit", "tarp kits"],
            redirectTo: "https://www.truckntow.com/collections/search-specialty-towing-and-securement-products-collection-42"
        },
        {
            terms: ["2\" ratchet straps", "2 inch ratchet straps"],
            redirectTo: "https://www.truckntow.com/collections/search-safety-chains-with-grab-hooks-for-secure-tie-downs-4"
        },
        {
            terms: ["Tax","tax exempt","taxexempt"],
            redirectTo: "https://www.truckntow.com/pages/taxexempt-form"
        },
        {
            terms: ["jumpercable","jumpercables","jumpcable","jumpcables","jumpercabel","jumpercabels","jumpcabel","jumpcabels"],
            redirectTo: "https://www.truckntow.com/electrical/jump-start.html?product_list_limit=36"
        },
        {
            terms: ["ratchett","ratchetts","rachett","rachetts"],
            redirectTo: "https://www.truckntow.com/ratchet-buckles.html?product_list_limit=36"
        },
        {
            terms: ["8-point","8-points"],
            redirectTo: "https://www.truckntow.com/search?q=8+point"
        },
        {
            terms: ["AH2-Flex"],
            redirectTo: "https://www.truckntow.com/products/vulcan-single-ply-2-axle-straps?variant=41658766983241"
        },
        {
            terms: ["Clearance Safety","clearence safety","clearence safty","clearance safty","cleerance safety","cleerence safety","cleerance safty","cleerence safty","clerence safety","clerence safty"],
            redirectTo: "https://www.truckntow.com/clearance-safety-apparel.html"
        },
        {
            terms: ["24x24x48","24 x 24 x 48"],
            redirectTo: "https://www.truckntow.com/tool-boxes.html"
        },
        {
            terms: ["lockout","lockouy","lockouts","lockouys","lockout kit","lockouy kit","lockouys"],
            redirectTo: "https://www.truckntow.com/towing-equipment/vehicle-entry-and-lock-out-tools.html?product_list_limit=36"
        },
        {
            terms: ["jumper","jump","jumps","jumpers","jumpr","jumprs","jumping"],
            redirectTo: "https://www.truckntow.com/electrical/jump-start.html?product_list_limit=36"
        },
        {
            terms: ["shackles","shacklr","shacklrs","shakle","shakles","shacle","shacles","shaclr","shaclrs","shaklrs","shaklr"],
            redirectTo: "https://www.truckntow.com/search?q=shackle"
        },
        {
            terms: ["recovery strap","recovry straps","recoverystrap","recoverystraps","recovrystrap","recovrystraps","recovry strap"],
            redirectTo: "https://www.truckntow.com/search?q=recovery+straps"
        },
        {
            terms: ["2 inch ratchet","2inch ratchet","rachete","rachet","rachete"],
            redirectTo: "https://www.truckntow.com/ratchet-buckles.html?product_list_limit=36"
        },
        {
            terms: ["catalogue","catalogs","catalog","catlog","catilog","catilogs"],
            redirectTo: "https://www.truckntow.com/catalog-request/"
        },
        {
            terms: ["tntgiftcard","giftcard","giftcertificate"],
            redirectTo: "https://www.truckntow.com/gift-card.html"
        },
        {
            terms: ["Cargowinches","cargo winches","cargowinch","cargo winch"],
            redirectTo: "https://www.truckntow.com/winches-accessories.html"
        },
        {
            terms: ["oversise","over sise","oversised","over sised"],
            redirectTo: "https://www.truckntow.com/search?q=oversize+load+signs"
        },
        {
            terms: ["winch rope","winch ropes"],
            redirectTo: "https://www.truckntow.com/towing-equipment/winch-cables-accessories.html"
        },
        {
            terms: ["broom","brooms","broms","broomms","bromes","brome","brume","brumes"],
            redirectTo: "https://www.truckntow.com/garage-tools/spill-kits-shop-cleanup.html"
        },
        {
            terms: ["Slim Jim","slimjim"],
            redirectTo: "https://www.truckntow.com/towing-equipment/vehicle-entry-and-lock-out-tools.html?product_list_limit=36"
        },
        {
            terms: ["scratch and dent","scratch and dents","scratch & dent","scratch & dents"],
            redirectTo: "https://www.truckntow.com/scratch-and-dent.html"
        },
        {
            terms: ["Frame Hook Clusters","Frame Hook Cluster","Fram Hook Clusters","Fram Hook Cluster"],
            redirectTo: "https://www.truckntow.com/tow-chains-straps/tow-hooks-tiedown-hooks/frame-hook-clusters.html"
        },
        {
            terms: ["lifting"],
            redirectTo: "https://www.truckntow.com/lifting.html"
        },
        {
            terms: ["Cargo Control"],
            redirectTo: "https://www.truckntow.com/cargo-control.html"
        },
        {
            terms: ["Gift Cards","Gift Card","Gift","Gift Certificate"],
            redirectTo: "https://www.truckntow.com/gift-card.html"
        },
        {
            terms: ["Binder Chains","Binder Chain","tie down chains","tie down chain"],
            redirectTo: "https://www.truckntow.com/binder-chains-tie-down.html?product_list_limit=36"
        },
        {
            terms: ["Interior Van"],
            redirectTo: "https://www.truckntow.com/e-track-logistic-straps-fittings.html?product_list_limit=36"
        },
        {
            terms: ["Wire Rope Sling","Wire Rope Slings"],
            redirectTo: "https://www.truckntow.com/wire-rope-lifting-slings.html"
        },
        {
            terms: ["Car Hauler Chains","Car Hauler Chain"],
            redirectTo: "https://www.truckntow.com/car-hauler-chains.html"
        },
        {
            terms: ["Car Hauler Straps","Car Hauler Strap"],
            redirectTo: "https://www.truckntow.com/car-hauler-straps.html?product_list_limit=36"
        },
        {
            terms: ["viro","Lockkits","lock kits","chain and lock kits","security chain and lock","security chain","security locks. security lock","security chains","hard chain","hard chains","Lock Kit"],
            redirectTo: "https://www.truckntow.com/anti-theft.html?product_list_limit=36"
        },
        {
            terms: ["Wheel Chocks","Wheel Chock"],
            redirectTo: "https://www.truckntow.com/towing-equipment/wheel-chocks.html?product_list_limit=36"
        },
        {
            terms: ["Cones"],
            redirectTo: "https://www.truckntow.com/traffic-management/cones-flares-triangles.html?product_list_limit=36"
        },
        {
            terms: ["Beacons","Beacon"],
            redirectTo: "https://www.truckntow.com/beacons.html?product_list_limit=36"
        },
        {
            terms: ["Battery Flasher"],
            redirectTo: "https://www.truckntow.com/portable-led-flashers.html"
        },
        {
            terms: ["recent orders","recent order","login","log in","logins","my account","account"],
            redirectTo: "https://www.truckntow.com/customer/account/login"
        },
        {
            terms: ["rear view camera","rear view cameras","backup camera","backup cameras","camera system","camera systems"],
            redirectTo: "https://www.truckntow.com/rear-view-video-systems.html"
        },
        {
            terms: ["Ratchet straps","ratchet strap","rachet straps","rachet strap","2\" rachet strap","2\" rachet straps","2\" ratchet strap","2\" ratchet straps","3\" ratchet straps","3\" ratchet strap","3\" rachet strap","3\" rachet straps","rachet straps 2inch","rachet strap 2inch"],
            redirectTo: "https://www.truckntow.com/ratchet-straps.html"
        },
        {
            terms: ["over the tire strap","over the tire straps"],
            redirectTo: "https://www.truckntow.com/car-hauler-straps.html?p=1&product_list_limit=36"
        },
        {
            terms: ["5/8 inch cam lock","cam lock","cam locks","5/8\" cam lock","cam lock plunger"],
            redirectTo: "https://www.truckntow.com/towing-equipment/heavy-duty-wrecker-accessories/cam-locks.html"
        },
        {
            terms: ["about us"],
            redirectTo: "http://www.truckntow.com/about-truckntow/"
        },
        {
            terms: ["accident clean up"],
            redirectTo: "https://www.truckntow.com/garage-tools/spill-kits-shop-cleanup.html?product_list_limit=36"
        },
        {
            terms: ["air compressor","air compressors"],
            redirectTo: "https://www.truckntow.com/garage-tools/air-compressors-hoses.html?product_list_limit=36"
        },
        {
            terms: ["air horns","airhorn"],
            redirectTo: "https://www.truckntow.com/search?q=air+horn"
        },
        {
            terms: ["apparel","safety apparel","safetyapparel","clothes","uniform","uniforms","apparel","clothing"],
            redirectTo: "https://www.truckntow.com/safety-apparel.html"
        },
        {
            terms: ["axle tiedowns","axel tiedowns","axel tie downs","axel strap","axle straps","axel tie-downs","axel tie-down","axle tie downs","axle tie down","axle tie-down"],
            redirectTo: "https://www.truckntow.com/tow-chains-straps/axle-straps-tie-back-straps.html?limit=36"
        },
        {
            terms: ["Back rack","headache racks","headache rack","chain rack","backracks"],
            redirectTo: "https://www.truckntow.com/headache-racks.html"
        },
        {
            terms: ["backup lights","stop lights","turn lights","tail lights","backup light","stop light","turn light","tail light","stop turn and tail lights"],
            redirectTo: "https://www.truckntow.com/stop-turn-tail-lights.html?product_list_limit=36"
        },
        {
            terms: ["Bridal chains","chain bridle","chain bridel","chain","bridels","chain bridal","chain bridals"],
            redirectTo: "https://www.truckntow.com/tow-chains-straps/v-bridles-chain.html?product_list_limit=36"
        },
        {
            terms: ["calendar","calender","calander","calender"],
            redirectTo: "https://www.truckntow.com/calendar/"
        },
        {
            terms: ["catalog","request catalog","catalogs","catlong","catalong","catalog request","catalog","catolog","catolag","catolog"],
            redirectTo: "https://www.truckntow.com/catalog-request/"
        },
        {
            terms: ["chain sling","chain slings","lifting slings","lifting sling"],
            redirectTo: "https://www.truckntow.com/chain-slings.html?product_list_limit=36"
        },
        {
            terms: ["clearance","sale","on sale","clarence","close outs","close out","closeouts","closeout"],
            redirectTo: "http://www.truckntow.com/clearance.html/"
        },
        {
            terms: ["coat with hood","rain coat","hi viz coats","hiviz coats","coat","coats","class 2 tow jacket","safety coats","safety coat"],
            redirectTo: "https://www.truckntow.com/safety-apparel/jackets-rain-gear.html?product_list_limit=36"
        },
        {
            terms: ["contact us","contact","phone number","mailing address"],
            redirectTo: "http://www.truckntow.com/contact-us/"
        },
        {
            terms: ["credit application","credit","apply for credit"],
            redirectTo: "https://www.truckntow.com/credit-application/"
        },
        {
            terms: ["Coupon","Promo","Deals","coupons","deal","promotion","deal of the day","daily deal","daily deals"],
            redirectTo: "https://www.truckntow.com/dailydeals"
        },
        {
            terms: ["durabilt load binders","ratchet binders","load binder","load binders","chain binder","heavy duty chain binders","chain binders","ratchet binder","ratcheting binders","binders"],
            redirectTo: "https://www.truckntow.com/load-binders.html"
        },
        {
            terms: ["financing","make payments"],
            redirectTo: "http://www.truckntow.com/financing/"
        },
        {
            terms: ["Free Shipping","free ship","shipping","shipping policy","shipping cost","free shipping","free shipping coupon","shipping coupon","how much is shipping"],
            redirectTo: "https://www.truckntow.com/shipping-policy"
        },
        {
            terms: ["full size light bars","light bars","light bar","warning bar","warning bars"],
            redirectTo: "https://www.truckntow.com/light-bars-full-size.html"
        },
        {
            terms: ["gojack","gojacks","gojak","gojaks"],
            redirectTo: "https://www.truckntow.com/garage-tools/gojak-casters-components.html"
        },
        {
            terms: ["hard hat reflective","hard hat","hard hats","green hard hats","hats","cowboy hard hats","reflective hard hat","reflective hard hats","reflective hat","reflective hats"],
            redirectTo: "https://www.truckntow.com/safety-apparel/hats.html?product_list_limit=36"
        },
        {
            terms: ["head light flashing units"],
            redirectTo: "https://www.truckntow.com/head-tail-light-flashers.html"
        },
        {
            terms: ["help","order help","customer service"],
            redirectTo: "https://www.truckntow.com/customer-support"
        },
        {
            terms: ["in cab comfort","in cab accessories"],
            redirectTo: "http://www.truckntow.com/cab-comfort.html"
        },
        {
            terms: ["inspection form","driver logs and inspections","driver log books","tow log book","dot inspection form","daily inspection forms","dot inspection forms","forms"],
            redirectTo: "https://www.truckntow.com/forms-logs-organizers.html?product_list_limit=36"
        },
        {
            terms: ["Cargo van straps","logistic straps","cargo van strap","logistic strap"],
            redirectTo: "https://www.truckntow.com/e-track-logistic-straps-fittings.html?product_list_limit=36"
        },
        {
            terms: ["Jackets","pants","rain gear","suits","bibs","overalls","raingear","raincoats","raincoat"],
            redirectTo: "https://www.truckntow.com/safety-apparel/jackets-rain-gear.html?limit=36&p=1&product_list_limit=36"
        },
        {
            terms: ["light","lights"],
            redirectTo: "http://www.truckntow.com/lights.html"
        },
        {
            terms: ["load boosters","load booster","front load booster","front load boosters","rear load booster","rear load booosters"],
            redirectTo: "https://www.truckntow.com/load-boosters.html?product_list_limit=36"
        },
        {
            terms: ["master ring","master rings"],
            redirectTo: "https://www.truckntow.com/master-rings.html?product_list_limit=36"
        },
        {
            terms: ["Motorcycle Tow Dolly","Motorcycle accessories","Motorcycle","Motorcycle straps","motorcycle tie down","motorcycle tie downs","Motorcycle Lift Kit","Motorcycle Lift kits","Motorcycle Handlebar Straps","Motorcycle Handle Bar Straps","Motorcycle Handlebar Strap","Motorcycle Handle bar strap"],
            redirectTo: "https://www.truckntow.com/towing-equipment/motorcycle-tie-down-transport.html?product_list_limit=36"
        },
        {
            terms: ["mud flap anti-sale bracket"],
            redirectTo: "https://www.truckntow.com/mud-flaps-hangers.html"
        },
        {
            terms: ["new product","new products","newproduct","newproducts","new"],
            redirectTo: "https://www.truckntow.com/new-products.html?product_list_limit=36"
        },
        {
            terms: ["Order","Order#","Order #","Order Tracking","track order"],
            redirectTo: "https://www.truckntow.com/customer/account/login/"
        },
        {
            terms: ["Pintle Hooks","trailer hitch","hitches","hitch"],
            redirectTo: "https://www.truckntow.com/towing-equipment/hitches.html?product_list_limit=36"
        },
        {
            terms: ["plug adapter","plug adapters"],
            redirectTo: "https://www.truckntow.com/electrical/trailer-light-adapters.html?product_list_limit=36"
        },
        {
            terms: ["portable power packs","Portable Power Pack","Jump Starter","Jump Starters","JumpnCarry","Jump N Carry","jumper","portable power pack","portable power packs","jump box","jump pack","plug in jumper cables","jump","jumper","jumpers","jump start","Jump starter","jumper cable","jumper cables","jumper connections","booster cables","booster cable","cables","powerboostercables","power booster cables","jumpercabel","jumper cabel","jumpercabels","jumper cabels"],
            redirectTo: "https://www.truckntow.com/electrical/jump-start.html?product_list_limit=36"
        },
        {
            terms: ["password recovery","reset my password"],
            redirectTo: "https://www.truckntow.com/customer/account/forgotpassword/"
        },
        {
            terms: ["product information","specs","docs","documents","documentation","How to place an order","how to use a coupon code","how to use a gift card"],
            redirectTo: "http://www.truckntow.com/support-library/"
        },
        {
            terms: ["push bumpers","push bumpers"],
            redirectTo: "https://www.truckntow.com/push-bumpers.html"
        },
        {
            terms: ["rachets","rachet","ratchet","ratchets","ratchet buckles","ratchet buckle","rachect"],
            redirectTo: "https://www.truckntow.com/ratchet-buckles.html?product_list_limit=36"
        },
        {
            terms: ["Tow Strap","Tow Straps","twostrap","twostraps","two strap","two straps"],
            redirectTo: "https://www.truckntow.com/tow-chains-straps/tow-straps-ropes-recovery-straps.html?product_list_limit=36"
        },
        {
            terms: ["Reflective vest","safety vest","safety vests","class 2 safety vest","class 2 safety vests","vests"],
            redirectTo: "https://www.truckntow.com/safety-apparel/vests.html?product_list_limit=36"
        },
        {
            terms: ["registration","registrations","register"],
            redirectTo: "https://www.truckntow.com/customer/account/create/"
        },
        {
            terms: ["returns","return policy","return"],
            redirectTo: "http://www.truckntow.com/return-policy/"
        },
        {
            terms: ["roadside warning","road signs","safety batons","barricades"],
            redirectTo: "http://www.truckntow.com/traffic-management.html"
        },
        {
            terms: ["Safety chain","safety chains"],
            redirectTo: "https://www.truckntow.com/tow-chains-straps/safety-chains.html?product_list_limit=36"
        },
        {
            terms: ["searchlight","search light","spotlight","spot light","searchlights","flood lights","work lights","led work lampfloog","work light","led work lamps","work light","led work light","led work lights","work lights","flood lights","flood light","led work lamp","led work lamps","work lamp","work lamps"],
            redirectTo: "https://www.truckntow.com/work-lights.html?product_list_limit=36"
        },
        {
            terms: ["Security","Anti Theft","Anti Theft devices","lock","locks"],
            redirectTo: "https://www.truckntow.com/anti-theft.html"
        },
        {
            terms: ["snatch block","snatch blocks"],
            redirectTo: "http://www.truckntow.com/towing-equipment/snatch-blocks.html"
        },
        {
            terms: ["steering wheel lock"],
            redirectTo: "http://www.truckntow.com/tow-chains-straps/steering-wheel-locks/nylon-steering-wheel-lock.html"
        },
        {
            terms: ["Steps"],
            redirectTo: "https://www.truckntow.com/step-accessories.html"
        },
        {
            terms: ["strap protector","plastic corner protectors","strap protectors","plastic corner protector","corner protector","corner protectors","edge protector","edge protectors"],
            redirectTo: "https://www.truckntow.com/corner-protectors.html"
        },
        {
            terms: ["strap v bridles","bridle strap","bridle straps","bridel strap","bridel straps","web v bridle","web v bridel","web v bridal","web bridel","web bridle","web bridles","web bridels","web v bridals","web b bridels","strap v bridel","strap v bridels","strap v bridle","strap v bridles"],
            redirectTo: "https://www.truckntow.com/tow-chains-straps/v-bridles-webbing.html?product_list_limit=36"
        },
        {
            terms: ["Strobe","strobe lights","strobe light"],
            redirectTo: "https://www.truckntow.com/strobes-flashing-led.html?&product_list_limit=36"
        },
        {
            terms: ["sweatshirt","sweatshirts","hiviz sweatshirt","hi viz sweatshirt","hiviz sweatshirts","hiviz sweatshirt"],
            redirectTo: "https://www.truckntow.com/safety-apparel/sweatshirts.html?product_list_limit=36"
        },
        {
            terms: ["switch panel","switch boxes","switch panel boxes","switch panels","switch box","panel box"],
            redirectTo: "https://www.truckntow.com/switch-panels.html?product_list_limit=36"
        },
        {
            terms: ["TAPE"],
            redirectTo: "https://www.truckntow.com/reflective-tape.html?&product_list_limit=36"
        },
        {
            terms: ["tie down systems","tie down system"],
            redirectTo: "http://www.truckntow.com/tow-chains-straps/tie-down-systems.html"
        },
        {
            terms: ["tire chain hangers for semi trailer"],
            redirectTo: "http://www.truckntow.com/tire-chain-racks.html"
        },
        {
            terms: ["Tire Skate"],
            redirectTo: "http://www.truckntow.com/wreckmaster-tire-skates-set-of-4.html"
        },
        {
            terms: ["tnt round sling","round sling","round slings","tnt round slings","roundsling","roundslings"],
            redirectTo: "https://www.truckntow.com/round-slings.html"
        },
        {
            terms: ["tool box","tool boxes","truck side boxes","under mount tool boxes"],
            redirectTo: "https://www.truckntow.com/tool-boxes.html"
        },
        {
            terms: ["tow bar"],
            redirectTo: "http://www.truckntow.com/towing-equipment/heavy-duty-wrecker-accessories/medium-duty-truck-tow-bar.html"
        },
        {
            terms: ["tow chain","tow chains"],
            redirectTo: "https://www.truckntow.com/tow-chains-straps/tow-chains.html?product_list_limit=36"
        },
        {
            terms: ["tow dolly straps"],
            redirectTo: "http://www.truckntow.com/tow-chains-straps/wheel-lift-dolly-straps.html"
        },
        {
            terms: ["tow hooks","tow hook"],
            redirectTo: "http://www.truckntow.com/tow-chains-straps/tow-hooks-tiedown-hooks/towing-hooks.html"
        },
        {
            terms: ["tow lights","tow light","wide load magnet lights","wide load magnet light","wireless tow lights","wireless tow light","wide load light","wide load lights","flat towing light kit","light kit for flat towing"],
            redirectTo: "https://www.truckntow.com/tow-lights-wide-load-bars.html?product_list_limit=36"
        },
        {
            terms: ["tow sling"],
            redirectTo: "http://www.truckntow.com/towing-equipment/heavy-duty-wrecker-accessories/replacement-sling-straps-individual.html"
        },
        {
            terms: ["traffic control arrows"],
            redirectTo: "https://www.truckntow.com/traffic-directors.html?product_list_limit=36"
        },
        {
            terms: ["truck lights"],
            redirectTo: "https://www.truckntow.com/stop-turn-tail-lights.html?product_list_limit=36"
        },
        {
            terms: ["truck tire chains","tire chain","tire chaings","cable tire chain","cable tire chains","tire cable","tire cables","snow chains","truck snow chains","automatic snow chains","tire Chains","tires cable","tires cables"],
            redirectTo: "https://www.truckntow.com/tirechainsandcables"
        },
        {
            terms: ["T-SHIRTS","hiviz t shirts","hiviz t shirts","hiviz t shirt","hi viz t shirts","hi viz t shirt","T Shirts"],
            redirectTo: "http://www.truckntow.com/safety-apparel/t-shirts.html"
        },
        {
            terms: ["unsubscribe","Unsubscribe"],
            redirectTo: "https://www.truckntow.com/contact-us/"
        },
        {
            terms: ["v-bridles","vbridles","v-bridals","vbridals","bridles","bridals","bridel"],
            redirectTo: "https://www.truckntow.com/tow-chains-straps/v-bridles-chain.html"
        },
        {
            terms: ["vehicle entry kit","vehicle entry","lockout kits","lock out tool","car entry","door tool kit","lockout tool","lockout equipment","access tools","car opening tools","lock out","lock out tools","lock out kit","lock out kits","lockout kit","lockout kits","door tools","lockout tools","Lockout"],
            redirectTo: "https://www.truckntow.com/towing-equipment/vehicle-entry-and-lock-out-tools.html?product_list_limit=36"
        },
        {
            terms: ["Vulcan Classic Yellow 3 Ply 2 Inch Axle Straps"],
            redirectTo: "https://www.truckntow.com/axle-straps.html?product_list_limit=36"
        },
        {
            terms: ["web slings","web sling"],
            redirectTo: "https://www.truckntow.com/polyester-slings.html"
        },
        {
            terms: ["wheel dolly","dolley","dolly","tow dolly","wheel dollies","tow dollies","car dolly"],
            redirectTo: "https://www.truckntow.com/towing-equipment/tow-dollies-components.html?product_list_limit=36"
        },
        {
            terms: ["wheel lift","wellift assesories","stinger straaps","stinger straps"],
            redirectTo: "https://www.truckntow.com/tow-chains-straps/wheel-lift-dolly-straps.html?limit=36"
        },
        {
            terms: ["Wheel Simulator","wheelsimulator","wheelsimulater","Wheel Simulater","wheelsimulators","wheelsimulaters","wheel simulators","wheel simulaters","chrome simulators","simulators","dot wheel simulators","wheel simulator","simulator","wheel sim"],
            redirectTo: "https://www.truckntow.com/wheel-simulators.html?product_list_limit=36"
        },
        {
            terms: ["Wheel Straps","Wheel Strap","tire strap","tire straps","tie down","tie downs","auto tie downs","auto tie down","car tie downs","car tie down"],
            redirectTo: "https://www.truckntow.com/car-hauler-straps.html?product_list_limit=36"
        },
        {
            terms: ["wide load mirror","mirror","mirrors","wide load mirrors"],
            redirectTo: "https://www.truckntow.com/mirrors.html?product_list_limit=36"
        },
        {
            terms: ["Wide Load","wide load","wideload","wide load accessories"],
            redirectTo: "https://www.truckntow.com/wide-load-accessories.html?product_list_limit=36"
        },
        {
            terms: ["winch strap","winch straps","whinch strap","whinch straps"],
            redirectTo: "https://www.truckntow.com/winch-straps.html"
        },
        {
            terms: ["winter work boots","water proof work boots","work boots","boots","footwear","footware"],
            redirectTo: "https://www.truckntow.com/safety-apparel/footwear.html?product_list_limit=36"
        },
        {
            terms: ["Wire rope","winch line","winch cable","winch cables"],
            redirectTo: "https://www.truckntow.com/towing-equipment/winch-cables-accessories.html?product_list_limit=36"
        },
        {
            terms: ["work boots","boots","shoes","footwear"],
            redirectTo: "https://www.truckntow.com/safety-apparel/footwear.html"
        },
        {
            terms: ["work gloves","winter work glove","gloves for drivers","truck gloves","truck work gloves","tow truck gloves","gloves","winter work gloves"],
            redirectTo: "https://www.truckntow.com/safety-apparel/gloves.html?product_list_limit=36"
        },
        {
            terms: ["wrecker bars","wrecker bar","wreker bars","wreker bar","Warning Bars","warning bar"],
            redirectTo: "https://www.truckntow.com/light-bars-full-size.html"
        }
    ];

    for (const rule of redirectRules) {
        if (rule.terms.includes(searchQuery)) {
            window.location.href = rule.redirectTo;
            break;
        }
    }
}